import { Flex, Text } from "@chakra-ui/react";

export function Trow({
  isHead = false,
  isPrice = false,
  isHeight = false,
  value,
  width,
  isBalance = false,
  disabled = false,
  index,
  ...rest
}) {
  return (
    <Flex
      paddingBlock={1}
      width={width ? width : "6rem"}
      bg={isHead ? "#1A8AB6" : isPrice ? "#ebebeb" : disabled ? "transparent" : "#ebebeb"}
      color={isHead ? "#fff" : isBalance ? "#1A8AB6" : "#333"}
      alignItems={"center"}
      justifyContent="center"
      position="relative"
      _after={{
        content: "''",
        width: "100%",
        height: "1px",
        display: "block",
        backgroundColor: "#fff",
        position: "absolute",
        bottom: "0",
        left: "0",
        right: "0",
        margin: "auto",
      }}
      {...rest}
    >
      <Flex
        fontSize="sm"
        textAlign="center"
        as="h1"
        height={isHeight ? "3.1rem" : ""}
        alignItems="center"
        justifyContent="center"
      >
        {value}
      </Flex>
    </Flex>
  );
}
